import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services/store-selectors.service";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {take} from 'rxjs/operators';

@Component({
    selector: 'app-scene-block-video',
    templateUrl: './block-video.component.html',
    styleUrls: ['./block-video.component.scss']
})
export class BlockVideoComponent extends BlockBaseComponent {
    resourceName = '';

    constructor(public override storeSelector: StoreSelectorsService, public override dialog: MatDialog, private translocoService: TranslocoService) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        super.submit(formValues);
    }

    override componentInit() {
        this.storeSelector.getResource(this.sceneItem.Data["0"].Resource["0"].$.resource)
            .pipe(take(1))
            .subscribe((v) => {
                this.resourceName = v.resource_name;
            });
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '1',
                label: this.translocoService.translate('general.volume', {}, this.translocoService.getActiveLang()),
                inputType: "range",
                min: 0,
                max: 1,
                step: 0.1,
                name: "volume",
                storePath: 'Data[0].Resource[0].Video[0].$.volume'
            },
            // isFullFeatures removed 1-11-2022
            // {
            //   type: "input",
            //   value: '1',
            //   label: this.translocoService.translate('general.alpha', {}, this.translocoService.getActiveLang()),
            //   inputType: "range",
            //   min: 0,
            //   max: 1,
            //   step: 0.1,
            //   name: "backgroundAlpha",
            //   storePath: 'Data[0].Resource[0].Video[0].$.backgroundAlpha'
            // },
            {
                type: "checkbox",
                value: '1',
                label: this.translocoService.translate('general.autoRewind', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "autoRewind",
                storePath: 'Data[0].Resource[0].Video[0].$.autoRewind'
            },
            {
                type: "checkbox",
                value: '1',
                label: this.translocoService.translate('general.maintainRatio', {}, this.translocoService.getActiveLang()),
                name: "maintain",
                storePath: 'Data[0].Resource[0].AspectRatio[0].$.maintain'
            }
            // ,{
            //     type: "checkbox",
            //     value: '1',
            //     label: this.translocoService.translate('general.useTextureVideo', {}, this.translocoService.getActiveLang()),
            //     inputType: "text",
            //     name: "useTextureVideo",
            //     storePath: 'Data[0].Resource[0].Video[0].$.useTextureVideo'
            // }
        ];
        this.uiConfigInit = this.appendGpu(this.uiConfigInit);
    }
}

